import * as React from "react";
import BaseLayout, { appLinks } from "../../components/BaseLayout";
import Home from "../../features/Home";
import HomePageFilter from "../../features/Home/HomePageFilter";

function HomeScreen() {
  return (
    <BaseLayout paddingTop>
      <HomePageFilter />
      <Home appLinks={appLinks} />
    </BaseLayout>
  );
}

export default HomeScreen;
